export const formatNumber = (number) => {
    let result = number.toString().padStart(6, '0')
    return result;
}

export const isNumeric = (value)  =>{
    return /^\d+$/.test(value);
}